import { render, staticRenderFns } from "./TryUploadModal.vue?vue&type=template&id=35bb1b4b&scoped=true&"
import script from "./TryUploadModal.vue?vue&type=script&lang=js&"
export * from "./TryUploadModal.vue?vue&type=script&lang=js&"
import style0 from "./TryUploadModal.vue?vue&type=style&index=0&id=35bb1b4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb1b4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35bb1b4b')) {
      api.createRecord('35bb1b4b', component.options)
    } else {
      api.reload('35bb1b4b', component.options)
    }
    module.hot.accept("./TryUploadModal.vue?vue&type=template&id=35bb1b4b&scoped=true&", function () {
      api.rerender('35bb1b4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/TryUploadModal.vue"
export default component.exports